import { render, staticRenderFns } from "./Broucher.vue?vue&type=template&id=6ad41356&scoped=true&"
import script from "./Broucher.vue?vue&type=script&lang=js&"
export * from "./Broucher.vue?vue&type=script&lang=js&"
import style0 from "./Broucher.vue?vue&type=style&index=0&id=6ad41356&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad41356",
  null
  
)

export default component.exports